import usePrivateAxios from "@/common/api/usePrivateAxios"
import { Mapper } from "@/common/services/mapper";
import { useQuery } from "@tanstack/react-query";

type useEstablishmentNotificationsConfigurationsAvailableNotificationsProps<T> = {
  filters?: {
    companyId?: string;
  }
  mapper?: (data: any) => T,
}

export const useEstablishmentNotificationsConfigurationsAvailableNotifications = <T,>({
  filters: { companyId } = {},
  mapper = Mapper.default<T>(),
}: useEstablishmentNotificationsConfigurationsAvailableNotificationsProps<T>) => {
  const privateAxios = usePrivateAxios();

  return useQuery({
    queryKey: ['establishmentCompanyNotificationConfigurationsAvailableNotifications', companyId],
    queryFn: () => privateAxios.get(`/establishment/company_notification_configurations/available_notifications`, {
      params: {
        'company_id': companyId,
      },
    }),
    select: (data) => mapper(data?.data?.data),
  });
}
